import Head from "next/head";
import { make as TrendsPage } from "../../src/trends/TrendsPage.bs";
import { allPatches } from "common/src/Config.ts";
import { fromUrl } from "common/src/Aperture.bs";

export default function Trends({
  currStats,
  pastStats,
  pastAugs,
  currAugs,
  prevPatch,
  currPatch,
}) {
  return (
    <>
      <Head>
        <title>TFT Set 18 Meta Trends</title>
      </Head>
      <TrendsPage
        prevPatch={prevPatch}
        currPatch={currPatch}
        currStats={currStats}
        pastStats={pastStats || undefined}
        currAugs={currAugs}
        pastAugs={pastAugs || undefined}
      />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ params }) {
  const aperture = fromUrl(params.slug || []);
  const currPatch = allPatches[0];
  const prevPatch = allPatches[1] ?? allPatches[0];
  const currResp = await fetch(
    `https://d3.tft.tools/stats2/general/${aperture.queue}/${currPatch}/${aperture.rankGroup}`,
  );
  const currStats = await currResp.json();

  let pastStats = null;
  try {
    const pastResp = await fetch(
      `https://d3.tft.tools/stats2/general/${aperture.queue}/${prevPatch}/${aperture.rankGroup}`,
    );
    if (pastResp.status === 200) {
      pastStats = await pastResp.json();
    }
  } catch (_) {}

  // const currAugsResp = await fetch(
  //   `https://d3.tft.tools/stats2/augments/${aperture.queue}/${currPatch}/${aperture.rankGroup}`,
  // );
  // const currAugs = await currAugsResp.json();

  // let pastAugs = null;
  // try {
  //   const prevAugsResp = await fetch(
  //     `https://d3.tft.tools/stats2/augments/${aperture.queue}/${prevPatch}/${aperture.rankGroup}`,
  //   );
  //   if (prevAugsResp.status === 200) {
  //     pastAugs = await prevAugsResp.json();
  //   }
  // } catch (_) {}

  return {
    props: {
      currStats,
      pastStats,
      // currAugs,
      // pastAugs,
      prevPatch,
      currPatch,
    },
    revalidate: 3600,
  };
}
